import React from "react";
import { CheckBox, NumberBox } from "devextreme-react";

const PasswordHistory = ({ onValueChange, value }) => {
  return (
    <div className='mb-5'>
      <table className='table table-bordered align-middle mt-1'>
        <thead className='table-dark'>
          <tr>
            <th scope='col'>Setting</th>
            <th scope='col'>Value</th>
            <th scope='col'>Explanation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope='row'>Users cannot re-use old passwords</th>
            <td className='text-center' style={{ width: "40%" }}>
              <CheckBox
                value={value.password_history_enabled}
                onValueChanged={(e) =>
                  onValueChange(e, "password_history_enabled")
                }
              />
            </td>
            <td style={{ width: "30%" }}></td>
          </tr>
          <tr>
            <th scope='row'>
              Number of previous passwords that cannot be re-used
            </th>
            <td className='text-center' style={{ width: "40%" }}>
              <NumberBox
                min={1}
                value={value.password_history_entries}
                onValueChanged={(e) =>
                  onValueChange(e, "password_history_entries")
                }
              />
            </td>
            <td style={{ width: "30%" }}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PasswordHistory;
